(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1683],{

/***/ 40076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76350);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var WrappedButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, props, {
        ref: ref
    }));
});
WrappedButton.displayName = "WrappedButton";
/* harmony default export */ __webpack_exports__["Z"] = (WrappedButton);


/***/ }),

/***/ 74748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56036);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89894);
/* harmony import */ var _packages_justo_parts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34053);
/* harmony import */ var src_page_components_Order_Products_ProductsContent_Category_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16574);






function informativeStamps(param) {
    var stamps = param.stamps, iconOnly = param.iconOnly;
    if (!(stamps === null || stamps === void 0 ? void 0 : stamps.length)) return null;
    var stampsRow = stamps.map(function(stamp, index) {
        var iconData = src_page_components_Order_Products_ProductsContent_Category_constants__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z[stamp];
        if (!iconData) return null;
        if (iconOnly) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row p-0.5 items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Tooltip__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    content: iconData.label,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: "dark:brightness-[5]",
                            alt: iconData.label,
                            src: iconData.URL,
                            width: "16",
                            height: "16"
                        })
                    })
                })
            }, index);
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-row rounded-3xl gap-x-1 bg-gray-100 dark:bg-zinc-700 px-2 py-0.5 items-center whitespace-nowrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "inline-block dark:brightness-[4] h-4 w-4",
                    alt: iconData.label,
                    src: iconData.URL,
                    width: "16px",
                    height: "16px",
                    layout: "fixed"
                }, index),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "inline-block text-sm align-text-top",
                    children: iconData.label
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex flex-row flex-wrap justify-start", {
            "flex-none": iconOnly,
            "gap-y-2 gap-x-3 px-5": !iconOnly
        }),
        children: stampsRow
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (informativeStamps);


/***/ }),

/***/ 52544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MultilineText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function MultilineText(props) {
    if (!props.children) return null;
    var lines = props.children.split("\n");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: lines.map(function(line, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    line,
                    index !== lines.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                ]
            }, index);
        })
    });
};


/***/ }),

/***/ 73002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PromotionTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _i18n_formatNumber_Component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18085);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32533);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56477);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function PromotionTag(param) {
    var product = param.product, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("website", {
        keyPrefix: "promotionType"
    }).t;
    var availabilityAt = product.availabilityAt, promotions = product.promotions;
    if (!(promotions === null || promotions === void 0 ? void 0 : promotions.length)) return null;
    if (!availabilityAt) return null;
    var finalPrice = availabilityAt.finalPrice;
    var pricing = {
        price: finalPrice,
        promotionType: promotions[0].promotionType
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_i18n_formatNumber_Component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                value: pricing.price
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().promotion),
                children: t(pricing.promotionType)
            })
        ]
    });
};


/***/ }),

/***/ 47758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ObjectField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var simple_react_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40191);
/* harmony import */ var simple_react_form__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(simple_react_form__WEBPACK_IMPORTED_MODULE_2__);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var ObjectField = /*#__PURE__*/ function(ObjectComponent1) {
    "use strict";
    _inherits(ObjectField, ObjectComponent1);
    var _super = _createSuper(ObjectField);
    function ObjectField() {
        _classCallCheck(this, ObjectField);
        return _super.apply(this, arguments);
    }
    var _proto = ObjectField.prototype;
    _proto.renderLabel = function renderLabel() {
        if (!this.props.label) return;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: this.props.label
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        });
    };
    _proto.renderErrorMessage = function renderErrorMessage() {
        if (!this.props.errorMessage) return;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                color: "red"
            },
            children: this.props.errorMessage
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: this.props.style,
            children: [
                this.renderLabel(),
                this.getChildrenComponents(),
                this.renderErrorMessage()
            ]
        });
    };
    return ObjectField;
}(simple_react_form__WEBPACK_IMPORTED_MODULE_2__.ObjectComponent);
ObjectField.propTypes = _objectSpread({}, simple_react_form__WEBPACK_IMPORTED_MODULE_2__.ObjectComponent.propTypes, {
    style: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
});
ObjectField.defaultProps = _objectSpread({}, simple_react_form__WEBPACK_IMPORTED_MODULE_2__.ObjectComponent.defaultProps, {
    style: {}
});



/***/ }),

/***/ 93865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ deleteCartItemMutation; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation deleteCartItem($cartItemId: ID) {\n    deleteCartItem(cartItemId: $cartItemId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var deleteCartItemMutation = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 71716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ withRefetchCart; },
/* harmony export */   "H0": function() { return /* binding */ useRefetchCart; }
/* harmony export */ });
/* unused harmony export refetchCartQuery */
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _data_fragments_cartFragment_cartItemFragment_main__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90932);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCartAndPrices($websiteId: ID) {\n    preferences: userPreferences(websiteId: $websiteId) {\n      _id\n      cart {\n        items {\n          _id\n          ...resumeCartItem\n        }\n        itemsPrice\n        realPrice: itemsPrice(includeDiscount: false)\n        totalPrice\n        amountToPay\n        deliveryFee\n        subtotal: itemsPrice(\n          includeDiscount: true\n          includeCoupon: true\n          includeJustoCoins: false\n          includeLoyaltyDiscount: false\n          includeWebsiteCoins: false\n        )\n        subtotalWithProductDiscount: itemsPrice(\n          includeDiscount: true\n          includeCoupon: false\n          includeJustoCoins: false\n          includeLoyaltyDiscount: false\n          includeWebsiteCoins: false\n        )\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var refetchCartQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject(), _data_fragments_cartFragment_cartItemFragment_main__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
var useRefetchCart = function() {
    var client = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useClient */ .m8)();
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return client.query({
                        query: refetchCartQuery,
                        variables: {
                            websiteId: websiteId
                        },
                        fetchPolicy: "network-only"
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
// eslint-disable-next-line react/display-name
var withRefetchCart = function(Component) {
    return function(props) {
        var refetchCart = useRefetchCart();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, _objectSpread({}, props, {
            refetchCart: refetchCart
        }));
    };
};


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 78425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAnalyticLocation; }
/* harmony export */ });
/* harmony import */ var _helpers_analytics_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54646);
/* harmony import */ var _helpers_router_getPathname__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48024);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



function useAnalyticLocation(eventType) {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var currentPath = (0,_helpers_router_getPathname__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(router);
    var ref1;
    return (ref1 = (ref = _helpers_analytics_events__WEBPACK_IMPORTED_MODULE_0__/* .ACTION_LOCATIONS */ .h[eventType]) === null || ref === void 0 ? void 0 : ref[currentPath]) !== null && ref1 !== void 0 ? ref1 : null;
};


/***/ }),

/***/ 1287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDisableScroll; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function useDisableScroll(disable) {
    return _useDisableScroll.apply(this, arguments);
};
function _useDisableScroll() {
    _useDisableScroll = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(disable) {
        return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
                        if (disable) {
                            document.body.style.overflow = "hidden";
                        }
                        return function() {
                            document.body.style.overflow = "unset";
                        };
                    }, [
                        disable
                    ]);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _useDisableScroll.apply(this, arguments);
}


/***/ }),

/***/ 74322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMeta; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_websites_PageMetaContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31469);


function useMeta(subtitle, description, image, schema) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_helpers_websites_PageMetaContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), setSubtitle = ref.setSubtitle, setDescription = ref.setDescription, setImage = ref.setImage, setSchema = ref.setSchema;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setSubtitle(subtitle);
        setDescription(description);
        setImage(image);
        setSchema(schema);
        return function() {
            setSubtitle();
            setDescription();
            setImage();
            setSchema();
        };
    }, []);
};


/***/ }),

/***/ 25932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrack; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation trackAction(\n            $type: String\n            $productId: ID\n            $orderId: ID\n            $path: String\n            $meta: JSON\n          ) {\n            trackAction(\n              type: $type\n              productId: $productId\n              orderId: $orderId\n              path: $path\n              meta: $meta\n            )\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useTrack() {
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMutate */ .Tu)();
    var track = function() {
        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, params) {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
                            variables: _objectSpread({}, params, {
                                type: type
                            })
                        });
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function track(type, params) {
            return _ref.apply(this, arguments);
        };
    }();
    return track;
};


/***/ }),

/***/ 18085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormatNumber; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78263);




/**
 * Formats the number as a currency using the locale of the current website obtained through the initialData context.
 */ function FormatNumber(param) {
    var value = param.value, _format = param.format, format = _format === void 0 ? "money" : _format, localeParam = param.locale, render = param.render, _removeSymbolPreffix = param.removeSymbolPreffix, removeSymbolPreffix = _removeSymbolPreffix === void 0 ? false : _removeSymbolPreffix;
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var locale = localeParam !== null && localeParam !== void 0 ? localeParam : initialData.website.country.locale;
    var number = (0,_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value, format, locale, removeSymbolPreffix);
    if (render) {
        return render(number);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: number
    });
};


/***/ }),

/***/ 10177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RI": function() { return /* binding */ CartLoadingProvider; },
/* harmony export */   "k6": function() { return /* binding */ useCartLoading; }
/* harmony export */ });
/* unused harmony export CartLoadingContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var CartLoadingContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    loading: false,
    setLoading: function() {}
});
var useCartLoading = function() {
    return react__WEBPACK_IMPORTED_MODULE_1__.useContext(CartLoadingContext);
};
var CartLoadingProvider = function(param) {
    var children = param.children;
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartLoadingContext.Provider, {
        value: {
            loading: loading,
            setLoading: setLoading
        },
        children: children
    });
};


/***/ }),

/***/ 16574:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var stamps = {
    VEGAN: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FYNHhFnJ49oaeNo4bh-VEGAN.svg",
        label: "Vegano"
    },
    VEGETARIAN: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FTtMZJWqFeoM6jXZPT-VEGETARIAN.svg",
        label: "Vegetariano"
    },
    CACAO_100: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FvyL8X6C4BMa3GmGPB-COCOA_100.svg",
        label: "100% cacao"
    },
    GLUTEN_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FpAkb6dT9J5BCNdw9b-GLUTEN_FREE.svg",
        label: "Sin gluten"
    },
    LACTOSE_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FXN85u2RmNmZzZbXwm-LACTOSE_FREE.svg",
        label: "Sin lactosa"
    },
    SUGAR_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2F9tFGhk4Yeo7CGrb4p-SUGAR_FREE.svg",
        label: "Sin az\xfacar"
    },
    RECYCLABLE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FuytNnxyQ8HnKkJgqe-RECYCLABLE.svg",
        label: "Reciclable"
    },
    SPICY: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FRo6uAC2RWMGg3Tqa7-SPICY.svg",
        label: "Picante"
    },
    RECYCLED: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2Ft2xxZt5dqeK5JxWSx-RECICLED.svg",
        label: "Reciclado"
    },
    HANDMADE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FDCynECNEfDyMFAaed-HANDMADE.svg",
        label: "Hecho a mano"
    },
    OLDER_THAN_18: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FKKF3DBuShnTzrNrLz-OLDER_THAN_18.svg",
        label: "Mayor de 18"
    },
    CRUELTY_FREE: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2FyNBMHBvXPe5gjraTt-CRUELTY_FREE.svg",
        label: "No testeado en animales"
    },
    KETO: {
        URL: "https://s3.amazonaws.com/orion-eat-app-files/buckets-prod%2Fv99t5FTchxQkpjgY3-KETO.svg",
        label: "Keto"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (stamps);


/***/ }),

/***/ 80885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAdd; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/data/queries/preferences/refetchCart.tsx
var preferences_refetchCart = __webpack_require__(71716);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useAnalyticLocation.ts
var useAnalyticLocation = __webpack_require__(78425);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./src/page-components/Order/CartLoadingContext.tsx
var CartLoadingContext = __webpack_require__(10177);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/mutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation addProductToCart(\n    $productId: ID\n    $amount: Float\n    $modifiers: [CartItemOptionInput]\n    $comment: String\n    $menuId: ID\n  ) {\n    item: addProductToCart(\n      productId: $productId\n      amount: $amount\n      modifiers: $modifiers\n      comment: $comment\n      menuId: $menuId\n    ) {\n      _id\n      totalPrice(includeDiscount: true)\n      unitPrice\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutation = ((0,lib["default"])(_templateObject()));

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/mutationEdit.ts
function mutationEdit_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mutationEdit_templateObject() {
    var data = mutationEdit_taggedTemplateLiteral([
        "\n  mutation updateCartItem(\n    $productId: ID\n    $amount: Float\n    $modifiers: [CartItemOptionInput]\n    $comment: String\n    $menuId: ID\n    $cartItemId: ID\n  ) {\n    item: updateCartItem(\n      cartItemId: $cartItemId\n      productId: $productId\n      amount: $amount\n      modifiers: $modifiers\n      comment: $comment\n      menuId: $menuId\n    ) {\n      _id\n      totalPrice(includeDiscount: true)\n      unitPrice\n    }\n  }\n"
    ]);
    mutationEdit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutationEdit = ((0,lib["default"])(mutationEdit_templateObject()));

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













function useAdd() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var showMessage = (0,useMessage/* default */.Z)();
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    var ref9 = (0,CartLoadingContext/* useCartLoading */.k6)(), setCartLoading = ref9.setLoading;
    var refetchCart = (0,preferences_refetchCart/* useRefetchCart */.H0)();
    var baseEventsProperties = (0,useEventsBaseProperties/* default */.Z)();
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("purchase");
    // TODO (Important): Refactor and set types
    return function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(props, state, product, resume) {
            var opts, setLoadingOpts, keepLoadingOnFinish, setLoading, success, variables, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, item, _modifiers, modifiers, requiredModifiers, productDiscount, ref8, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        opts = _args.length > 4 && _args[4] !== void 0 ? _args[4] : {};
                        setLoadingOpts = opts.setLoading, keepLoadingOnFinish = opts.keepLoadingOnFinish;
                        setLoading = function(loading) {
                            if (setLoadingOpts) setLoadingOpts(loading);
                            setCartLoading(loading);
                        };
                        success = false;
                        if (!resume.missingModifier) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,fireEvent["default"])("scrollToRequiredModifier", resume.missingModifier);
                        return _ctx.abrupt("return");
                    case 7:
                        setLoading(true);
                        _ctx.prev = 8;
                        variables = {
                            productId: props.product._id,
                            amount: state.amount,
                            modifiers: state.modifiers,
                            comment: state.comment,
                            menuId: props.menuId
                        };
                        if (!props.cartItem) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 13;
                        return mutate({
                            mutation: mutationEdit,
                            variables: _objectSpread({
                                cartItemId: props.cartItem._id
                            }, variables)
                        });
                    case 13:
                        _ctx.next = 28;
                        break;
                    case 15:
                        ;
                        _ctx.next = 18;
                        return mutate({
                            mutation: mutation,
                            variables: variables
                        });
                    case 18:
                        item = _ctx.sent.item;
                        _ctx.next = 21;
                        return refetchCart();
                    case 21:
                        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.ADDTOCART */.X.ADDTOCART, {
                            product: product,
                            item: item,
                            amount: state.amount
                        });
                        ;
                        modifiers = (_modifiers = product.modifiers) !== null && _modifiers !== void 0 ? _modifiers : [];
                        requiredModifiers = modifiers.filter(function(modifier) {
                            return !modifier.optional;
                        });
                        productDiscount = Math.round(((ref = product.availabilityAt) === null || ref === void 0 ? void 0 : ref.basePrice) - ((ref1 = product.availabilityAt) === null || ref1 === void 0 ? void 0 : ref1.finalPrice));
                        ;
                        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productAdded */.F.purchase.productAdded, _objectSpread({
                            categoryId: ((ref2 = product.categories) === null || ref2 === void 0 ? void 0 : ref2.length) ? product.categories[0]._id : "",
                            categoryName: ((ref3 = product.categories) === null || ref3 === void 0 ? void 0 : ref3.length) ? product.categories[0].name : "",
                            productName: product.name,
                            productId: (ref4 = props.product) === null || ref4 === void 0 ? void 0 : ref4._id,
                            productDescription: product.description,
                            productAmount: state.amount,
                            fullPrice: (ref5 = product.availabilityAt) === null || ref5 === void 0 ? void 0 : ref5.basePrice,
                            productDiscount: productDiscount > 0 ? productDiscount : 0,
                            productTotalPrice: ((ref8 = (ref6 = product.availabilityAt) === null || ref6 === void 0 ? void 0 : ref6.finalPrice) !== null && ref8 !== void 0 ? ref8 : 0) * state.amount,
                            amountRequiredModifiers: requiredModifiers.length,
                            amountOptionalModifiers: modifiers.length - requiredModifiers.length,
                            selectedOptionalModifiers: ((ref7 = state.modifiers) === null || ref7 === void 0 ? void 0 : ref7.length) - requiredModifiers.length,
                            actionLocation: actionLocation,
                            menuId: props.menuId
                        }, baseEventsProperties));
                    case 28:
                        if (props.onAdd) {
                            props.onAdd();
                        }
                        props.close();
                        success = true;
                        _ctx.next = 36;
                        break;
                    case 33:
                        _ctx.prev = 33;
                        _ctx.t0 = _ctx["catch"](8);
                        showMessage(_ctx.t0);
                    case 36:
                        setCartLoading(false);
                        // In some cases, we want to keep showing the loading state until the location changes
                        if (success && !keepLoadingOnFinish) setLoading(false);
                    case 38:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    33
                ]
            ]);
        }));
        return function(props, state, product, resume) {
            return _ref.apply(this, arguments);
        };
    }();
};


/***/ }),

/***/ 1683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WrappedSelectProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(54356);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-click-outside/build/index.js
var build = __webpack_require__(48683);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(23594);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main.ts
var usePreferencesForAddressContext_main = __webpack_require__(38417);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./src/hooks/useDisableScroll.ts
var useDisableScroll = __webpack_require__(1287);
// EXTERNAL MODULE: ./src/hooks/useIsDarkMode.ts
var useIsDarkMode = __webpack_require__(54731);
// EXTERNAL MODULE: ./src/hooks/useKeyboardEvent.ts
var useKeyboardEvent = __webpack_require__(1626);
// EXTERNAL MODULE: ./src/data/queries/preferences/getMyOrderPreferencesSlim.main.ts
var getMyOrderPreferencesSlim_main = __webpack_require__(63879);
// EXTERNAL MODULE: ./src/data/queries/website/websiteMenuInformation.main.tsx + 1 modules
var websiteMenuInformation_main = __webpack_require__(41372);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/hooks/usePageMeta.ts
var usePageMeta = __webpack_require__(74322);
// EXTERNAL MODULE: ./src/i18n/getCurrencyCode.ts
var getCurrencyCode = __webpack_require__(2298);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/PageMeta.tsx



function PageMeta(props) {
    var product = props.product;
    var router = (0,next_router.useRouter)();
    var image = product.images && product.images[0];
    var offer = product.availabilityAt ? {
        "@type": "Offer",
        url: router.asPath,
        priceCurrency: (0,getCurrencyCode/* default */.Z)(),
        price: product.availabilityAt.finalPrice
    } : null;
    var schema = image ? {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product.name,
        image: [
            image.imageLarge
        ],
        sku: product._id,
        description: product.description,
        offers: offer
    } : null;
    (0,usePageMeta/* default */.Z)(props.product.name, props.product.description, image, schema);
    return null;
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/index.tsx + 1 modules
var DeliveryWizard = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/data/queries/preferences/refetchCart.tsx
var preferences_refetchCart = __webpack_require__(71716);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/hooks/useAnalyticLocation.ts
var useAnalyticLocation = __webpack_require__(78425);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/hooks/useExperiment.experiments.tsx
var useExperiment_experiments = __webpack_require__(13505);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/useSelectProductModalV2.tsx


function useSelectProductModalV2() {
    var branchId = (0,useExperiment_experiments/* default */.Z)("select-product-modal-v2");
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    return branchId === "enabled" && !isDarkMode;
}
/* harmony default export */ var SelectProduct_useSelectProductModalV2 = (useSelectProductModalV2);

// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/hooks/useCartItems.main.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query selectProductActionsCartItems($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          menuId\n          cart {\n            items {\n              _id\n              productId\n              amount\n              isOutOfStock\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useSelectProductCartItems() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var preferences = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        }
    }).preferences;
    return preferences;
};

// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/data/mutations/cart/deleteCartItem.ts
var deleteCartItem = __webpack_require__(93865);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/Delete/useDelete.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function useDelete() {
    var mutate = (0,apollo_hooks_es/* useMutate */.Tu)();
    var showMessage = (0,useMessage/* default */.Z)();
    var refetchCart = (0,preferences_refetchCart/* useRefetchCart */.H0)();
    return function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(cartItemId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: deleteCartItem/* deleteCartItemMutation */.r,
                            variables: {
                                cartItemId: cartItemId
                            }
                        });
                    case 3:
                        _ctx.next = 5;
                        return refetchCart();
                    case 5:
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        showMessage(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(cartItemId) {
            return _ref.apply(this, arguments);
        };
    }();
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/Delete/styles.module.css
var styles_module = __webpack_require__(1795);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/Delete/index.tsx
function Delete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Delete_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Delete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Delete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










function Delete(props) {
    var close = props.close, cartItem = props.cartItem, menuId = props.menuId;
    var deleteItem = useDelete();
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("purchaseEdit");
    var remove = function() {
        var _ref = Delete_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        close();
                        _ctx.next = 4;
                        return (0,sleep/* default */.Z)(200);
                    case 4:
                        _ctx.next = 6;
                        return deleteItem(cartItem._id);
                    case 6:
                        ;
                        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productEdited */.F.purchase.productEdited, _objectSpread({}, baseEventProperties, {
                            productEditAction: "delete",
                            productId: cartItem === null || cartItem === void 0 ? void 0 : cartItem.productId,
                            productAmount: 0,
                            isAmountEdited: false,
                            isOutOfStock: (ref = cartItem === null || cartItem === void 0 ? void 0 : cartItem.isOutOfStock) !== null && ref !== void 0 ? ref : false,
                            menuId: menuId !== null && menuId !== void 0 ? menuId : "",
                            actionLocation: actionLocation
                        }));
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function remove() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (styles_module_default()).button,
            onClick: remove,
            children: "Eliminar"
        })
    });
};

// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/TiramisuButton/Price/index.tsx


function Price(param) {
    var resume = param.resume;
    var price = resume.price;
    if (!price) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
        value: Math.max(price, 0)
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/TiramisuButton/styles.module.css
var TiramisuButton_styles_module = __webpack_require__(81251);
var TiramisuButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(TiramisuButton_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/TiramisuButton/index.tsx
function TiramisuButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function TiramisuButton_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                TiramisuButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                TiramisuButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










function TiramisuButton(param) {
    var cartItem = param.cartItem, isAddingToCart = param.isAddingToCart, add = param.add, refetchCart = param.refetchCart, resume = param.resume;
    var t = (0,esm/* useTranslation */.$G)("website").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                loading: isAddingToCart,
                className: (TiramisuButton_styles_module_default()).button,
                onClick: TiramisuButton_asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                add();
                                if (!cartItem) {
                                    _ctx.next = 4;
                                    break;
                                }
                                _ctx.next = 4;
                                return refetchCart === null || refetchCart === void 0 ? void 0 : refetchCart();
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                        content: !resume.ready ? t("".concat(translatePrefix, ".labelCompleteAll")) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/tiramisu/shopping-basket.svg",
                        alt: "shopping basket",
                        width: "40px",
                        height: "40px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center font-bold text-vibrant-red text-xl px-2.5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                            resume: resume
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/styles.module.css
var Actions_styles_module = __webpack_require__(58471);
var Actions_styles_module_default = /*#__PURE__*/__webpack_require__.n(Actions_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/index.tsx
function Actions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Actions_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Actions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Actions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Actions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Actions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Actions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}























var translatePrefix = "order.products.productsContent.selectProduct.inner.actions";
var Actions = function(props) {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref5 = useSelectProductCartItems(), cart = ref5.cart, menuId = ref5.menuId;
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var ref1 = (0,react.useState)(false), isAddressModalOpen = ref1[0], setIsAddressModalOpen = ref1[1];
    var cartItem1 = props.allowEdit ? cart === null || cart === void 0 ? void 0 : cart.items.find(function(item) {
        return item.productId === props.product._id;
    }) : null;
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    var actionLocation = (0,useAnalyticLocation/* default */.Z)("purchaseEdit");
    var useSelectProductV2 = SelectProduct_useSelectProductModalV2();
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var containerClass = isDarkMode ? (Actions_styles_module_default()).containerDark : (Actions_styles_module_default()).container;
    var amounButtonClass = isDarkMode ? (0,classnames/* default */.Z)((Actions_styles_module_default()).amountButton, (Actions_styles_module_default()).amountButtonDark) : (Actions_styles_module_default()).amountButton;
    var renderButton = (0,react.useCallback)(function(adds, param) {
        var maxPurchaseQuantity = param.maxPurchaseQuantity, cartItem = param.cartItem;
        var Icon = adds ? index_esm/* MdAdd */.x06 : index_esm/* MdRemove */.eqC;
        var diff = adds ? 1 : -1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: amounButtonClass,
            onClick: function() {
                var amount = props.state.amount + diff;
                if (amount === 0) return;
                if (maxPurchaseQuantity && amount > maxPurchaseQuantity) return;
                if (cartItem && maxPurchaseQuantity && cartItem.amount + amount > maxPurchaseQuantity) return;
                props.onChange({
                    amount: amount
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                size: 20
            })
        });
    }, [
        props.state,
        props.product,
        props.onChange
    ]);
    var renderPrice = (0,react.useCallback)(function() {
        var price = props.resume.price;
        if (!price) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
            value: Math.max(price, 0)
        });
    }, [
        props.resume
    ]);
    var renderNoStore = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Actions_styles_module_default()).options,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("".concat(translatePrefix, ".labelAddAddressOrSelectStore"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsComponent */.Z.AsComponent, {})
                    })
                })
            ]
        });
    }, []);
    var renderDelete = (0,react.useCallback)(function() {
        if (!cartItem1) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete, {
            cartItem: cartItem1,
            close: props.close,
            menuId: menuId
        });
    }, [
        cartItem1,
        props.close
    ]);
    var renderNotAvailable = (0,react.useCallback)(function() {
        var message = props.product.availabilityAt.notAvailableMessage || t("".concat(translatePrefix, ".labelProductNotAvailable"));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: containerClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).outOfStockMessage,
                    children: message
                }),
                renderDelete()
            ]
        });
    }, [
        props.product,
        renderDelete
    ]);
    var renderAddButton = (0,react.useCallback)(function() {
        var tooltipText = cartItem1 ? "edit" : "add";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            loading: props.isAddingToCart,
            className: (Actions_styles_module_default()).buttonLegacy,
            primary: true,
            onClick: Actions_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref2, ref3, ref4;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (preferences === null || preferences === void 0 ? void 0 : preferences.storeId) {
                                _ctx.next = 3;
                                break;
                            }
                            setIsAddressModalOpen(true);
                            return _ctx.abrupt("return");
                        case 3:
                            props.add();
                            if (!cartItem1) {
                                _ctx.next = 10;
                                break;
                            }
                            ;
                            ;
                            (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productEdited */.F.purchase.productEdited, Actions_objectSpread({}, baseEventProperties, {
                                productEditAction: "edit",
                                productId: (ref3 = cartItem1 === null || cartItem1 === void 0 ? void 0 : cartItem1.productId) !== null && ref3 !== void 0 ? ref3 : "",
                                productAmount: props === null || props === void 0 ? void 0 : (ref = props.state) === null || ref === void 0 ? void 0 : ref.amount,
                                isAmountEdited: true,
                                isOutOfStock: (ref4 = cartItem1 === null || cartItem1 === void 0 ? void 0 : cartItem1.isOutOfStock) !== null && ref4 !== void 0 ? ref4 : false,
                                menuId: menuId !== null && menuId !== void 0 ? menuId : "",
                                actionLocation: actionLocation
                            }));
                            _ctx.next = 10;
                            return (ref2 = props.refetchCart) === null || ref2 === void 0 ? void 0 : ref2.call(props);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                content: !props.resume.ready ? t("".concat(translatePrefix, ".labelCompleteAll")) : null,
                children: t("fields.".concat(tooltipText), {
                    ns: "generic"
                })
            })
        });
    }, [
        props.isAddingToCart,
        props.add,
        cartItem1,
        props.refetchCart,
        props.resume.ready
    ]);
    var renderAddButtonV2 = (0,react.useCallback)(function() {
        var tooltipText = cartItem1 ? "edit" : "add";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                loading: props.isAddingToCart,
                className: (0,classnames/* default */.Z)((Actions_styles_module_default()).button, "justify-between"),
                primary: true,
                onClick: Actions_asyncToGenerator(runtime_default().mark(function _callee() {
                    var ref, ref6, ref7, ref8;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (preferences === null || preferences === void 0 ? void 0 : preferences.storeId) {
                                    _ctx.next = 3;
                                    break;
                                }
                                setIsAddressModalOpen(true);
                                return _ctx.abrupt("return");
                            case 3:
                                props.add();
                                if (!cartItem1) {
                                    _ctx.next = 10;
                                    break;
                                }
                                ;
                                ;
                                (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.productEdited */.F.purchase.productEdited, Actions_objectSpread({}, baseEventProperties, {
                                    productEditAction: "edit",
                                    productId: (ref7 = cartItem1 === null || cartItem1 === void 0 ? void 0 : cartItem1.productId) !== null && ref7 !== void 0 ? ref7 : "",
                                    productAmount: props === null || props === void 0 ? void 0 : (ref = props.state) === null || ref === void 0 ? void 0 : ref.amount,
                                    isAmountEdited: true,
                                    isOutOfStock: (ref8 = cartItem1 === null || cartItem1 === void 0 ? void 0 : cartItem1.isOutOfStock) !== null && ref8 !== void 0 ? ref8 : false,
                                    menuId: menuId !== null && menuId !== void 0 ? menuId : "",
                                    actionLocation: actionLocation
                                }));
                                _ctx.next = 10;
                                return (ref6 = props.refetchCart) === null || ref6 === void 0 ? void 0 : ref6.call(props);
                            case 10:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between flex-row w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex gap-2 items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip["default"], {
                                content: !props.resume.ready ? t("".concat(translatePrefix, ".labelCompleteAll")) : null,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShoppingCart */.kcE, {
                                        size: 18,
                                        "aria-label": "cart"
                                    }),
                                    " ",
                                    t("fields.".concat(tooltipText), {
                                        ns: "generic"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: renderPrice()
                        })
                    ]
                })
            })
        });
    }, [
        props.isAddingToCart,
        props.add,
        cartItem1,
        props.refetchCart,
        props.resume.ready
    ]);
    var renderOutOfStock = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: containerClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).outOfStockMessage,
                    children: t("".concat(translatePrefix, ".labelProductOutOfStock"))
                }),
                renderDelete()
            ]
        });
    }, [
        renderDelete
    ]);
    var renderMaxPurchaseQuantity = (0,react.useCallback)(function(maxPurchaseQuantity) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: containerClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).outOfStockMessage,
                    children: t("".concat(translatePrefix, ".labelMaxPurchaseQuantity"), {
                        max: maxPurchaseQuantity
                    })
                }),
                renderDelete()
            ]
        });
    }, [
        renderDelete
    ]);
    var renderTiramisuButton = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TiramisuButton, {
            cartItem: cartItem1,
            add: props.add,
            isAddingToCart: props.isAddingToCart,
            refetchCart: props.refetchCart,
            resume: props.resume
        });
    }, [
        cartItem1,
        props.add,
        props.isAddingToCart,
        props.refetchCart,
        props.resume
    ]);
    var amount1 = props.state.amount;
    var maxPurchaseQuantity1 = props.product.maxPurchaseQuantity;
    if (props.isOutOfStock) return renderOutOfStock();
    if (!props.product.availabilityAt) return renderNoStore();
    if (!props.product.availabilityAt.available) return renderNotAvailable();
    if (cartItem1 && maxPurchaseQuantity1 && cartItem1.amount >= maxPurchaseQuantity1) return renderMaxPurchaseQuantity(maxPurchaseQuantity1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: containerClass,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Actions_styles_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Actions_styles_module_default()).amount,
                        children: [
                            renderButton(false, {
                                maxPurchaseQuantity: maxPurchaseQuantity1,
                                cartItem: cartItem1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Actions_styles_module_default()).amountValue,
                                children: amount1
                            }),
                            renderButton(true, {
                                maxPurchaseQuantity: maxPurchaseQuantity1,
                                cartItem: cartItem1
                            })
                        ]
                    }),
                    props.layout === "tiramisu" ? renderTiramisuButton() : useSelectProductV2 ? renderAddButtonV2() : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            renderAddButton(),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Actions_styles_module_default()).price,
                                children: renderPrice()
                            })
                        ]
                    })
                ]
            }),
            renderDelete(),
            isAddressModalOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsModal */.Z.AsModal, {
                isOpen: isAddressModalOpen,
                highZIndex: true,
                canClickOutside: false,
                onClose: function() {
                    setIsAddressModalOpen(false);
                },
                actionLocation: "product-details"
            }) : null
        ]
    });
};
/* harmony default export */ var Inner_Actions = ((0,preferences_refetchCart/* withRefetchCart */.BS)(Actions));

// EXTERNAL MODULE: ./src/components/MultilineText/index.tsx
var MultilineText = __webpack_require__(52544);
// EXTERNAL MODULE: ./src/components/PromotionTag/index.tsx
var PromotionTag = __webpack_require__(73002);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/page-components/Order/warningBox.tsx
var warningBox = __webpack_require__(1829);
// EXTERNAL MODULE: ./src/components/InformativeStampsV2/index.tsx
var InformativeStampsV2 = __webpack_require__(74748);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/useOnEvent.js
var useOnEvent = __webpack_require__(80967);
// EXTERNAL MODULE: ./src/components/fields/ObjectField/index.tsx
var ObjectField = __webpack_require__(47758);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/hooks/useWidth.ts
var useWidth = __webpack_require__(9177);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var simple_react_form_lib = __webpack_require__(40191);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getFilteredModifiers.ts
function getFilteredModifiers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function getFilteredModifiers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            getFilteredModifiers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function getFilteredModifiers(modifiers, values) {
    return modifiers.map(function(modifierGroup, index) {
        var allModifierOptions = modifierGroup.options || [];
        var modifierOptions = allModifierOptions.filter(function(modifierOption) {
            var ref2, ref1;
            if (!((ref2 = modifierOption.availabilityAt) === null || ref2 === void 0 ? void 0 : ref2.available)) return false;
            if (modifierOption === null || modifierOption === void 0 ? void 0 : (ref1 = modifierOption.requiresModifierOptionIds) === null || ref1 === void 0 ? void 0 : ref1.length) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function(_iterator, _step) {
                        var requiredOptionId = _step.value;
                        var ref3;
                        var hasThisOption = !!((ref3 = values.modifiers) === null || ref3 === void 0 ? void 0 : ref3.find(function(modifier) {
                            var ref;
                            return (ref = modifier.optionsIds) === null || ref === void 0 ? void 0 : ref.includes(requiredOptionId);
                        }));
                        if (!hasThisOption) return {
                            v: false
                        };
                    };
                    for(var _iterator = ((modifierOption === null || modifierOption === void 0 ? void 0 : modifierOption.requiresModifierOptionIds) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = _loop(_iterator, _step);
                        if (_typeof(_ret) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return true;
        });
        return getFilteredModifiers_objectSpread({
            index: index
        }, modifierGroup, {
            options: modifierOptions
        });
    }).filter(function(modifierGroup) {
        var ref;
        return ((ref = modifierGroup.options) === null || ref === void 0 ? void 0 : ref.length) > 0;
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/styles.module.css
var Modifiers_styles_module = __webpack_require__(45546);
var Modifiers_styles_module_default = /*#__PURE__*/__webpack_require__.n(Modifiers_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Comments/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (Comments_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var Comments_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var Comments_translatePrefix = "order.products.productsContent.selectProduct.inner.details.modifiers.comments";
var Text = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Text, _Component);
    var _super = _createSuper(Text);
    function Text() {
        _classCallCheck(this, Text);
        return _super.apply(this, arguments);
    }
    var _proto = Text.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Modifiers_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Modifiers_styles_module_default()).labelContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifiers_styles_module_default()).label,
                        children: this.props.t("".concat(Comments_translatePrefix, ".labelSpecialInstructions"))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    value: this.props.value || "",
                    onChange: function(event) {
                        return _this.props.onChange(event.target.value);
                    },
                    className: (Modifiers_styles_module_default()).textarea,
                    placeholder: this.props.t("".concat(Comments_translatePrefix, ".labelIncludeNote")),
                    rows: 2
                })
            ]
        });
    };
    return Text;
}(react.Component);
/* harmony default export */ var Comments = ((0,esm/* withTranslation */.Zh)()(Text));

// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var clone = __webpack_require__(66678);
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Checkbox/styles.module.css
var Checkbox_styles_module = __webpack_require__(85792);
var Checkbox_styles_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Checkbox/index.tsx




function Checkbox(props) {
    var Icon = props.count ? index_esm/* MdCheckBox */.y5A : index_esm/* MdCheckBoxOutlineBlank */.hrt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.count || props.canAdd ? (Checkbox_styles_module_default()).container : (Checkbox_styles_module_default()).containerDisabled,
        onClick: props.toggle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            size: 24
        })
    });
};

// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Count/styles.module.css
var Count_styles_module = __webpack_require__(9899);
var Count_styles_module_default = /*#__PURE__*/__webpack_require__.n(Count_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Count/index.tsx





function Count(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Count_styles_module_default()).activeContainer,
        children: [
            props.count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: props.count > 0 ? (Count_styles_module_default()).icon : (Count_styles_module_default()).iconDisabled,
                        onClick: props.subtract,
                        role: "button",
                        "aria-label": "remove_button",
                        "aria-disabled": props.count === 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdRemoveCircleOutline */.X6R, {
                            size: 24,
                            "aria-label": "remove_icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Count_styles_module_default()).count,
                        "aria-label": "option_count",
                        children: (0,formatNumber/* default */.Z)(props.count, "0,0")
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: props.canAdd ? (Count_styles_module_default()).icon : (Count_styles_module_default()).iconDisabled,
                onClick: props.add,
                role: "button",
                "aria-label": "add_button",
                "aria-disabled": !props.canAdd,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdAddCircleOutline */.OrI, {
                    size: 24,
                    "aria-label": "add_icon"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Radio/styles.module.css
var Radio_styles_module = __webpack_require__(12563);
var Radio_styles_module_default = /*#__PURE__*/__webpack_require__.n(Radio_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Radio/index.tsx




function Radio(props) {
    var Icon = props.count ? index_esm/* MdRadioButtonChecked */.br6 : index_esm/* MdRadioButtonUnchecked */.bSN;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Radio_styles_module_default()).container,
        onClick: props.select,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            size: 24
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/index.tsx
function Input_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Input_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Input_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Input(props) {
    var option = props.option, modifier = props.modifier;
    if (modifier.max === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, Input_objectSpread({}, props, {
            color: "blue"
        }));
    }
    if (option.max === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, Input_objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Count, Input_objectSpread({}, props));
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Price/styles.module.css
var Price_styles_module = __webpack_require__(94622);
var Price_styles_module_default = /*#__PURE__*/__webpack_require__.n(Price_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Price/index.tsx







function Price_Price(props) {
    var option = props.option;
    var t = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }).t;
    var availability = option.availabilityAt;
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var outOfStockClass = isDarkMode ? (0,classnames/* default */.Z)((Price_styles_module_default()).outOfStock, (Price_styles_module_default()).outOfStockDark) : (Price_styles_module_default()).outOfStock;
    if (option.isOutOfStock) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: outOfStockClass,
        children: t("outOfStock")
    });
    if (!availability.price) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "font-semibold text-black dark:text-white ",
        children: [
            availability.price >= 0 ? "" : "-",
            " ",
            (0,formatNumber/* default */.Z)(Math.abs(availability.price), "money")
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/styles.module.css
var Option_styles_module = __webpack_require__(84715);
var Option_styles_module_default = /*#__PURE__*/__webpack_require__.n(Option_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/index.tsx
function Option_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Option_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Option_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function Option(props) {
    var modifier = props.modifier, option = props.option, optionsIds = props.optionsIds, onChange = props.onChange, image = props.image;
    var count = optionsIds.filter(function(optionId) {
        return optionId === option._id;
    }).length;
    var canAdd = true;
    if (option.max && count >= option.max) {
        canAdd = false;
    }
    if (modifier.max && optionsIds.length >= modifier.max) {
        canAdd = false;
    }
    if (option.isOutOfStock) {
        canAdd = false;
    }
    var add = function() {
        if (!canAdd) return;
        var value = clone_default()(optionsIds);
        value.push(option._id);
        onChange(value);
    };
    var subtract = function() {
        if (option.isOutOfStock) return;
        var value = clone_default()(optionsIds);
        var index = value.indexOf(option._id);
        if (index > -1) {
            value.splice(index, 1);
        }
        onChange(value);
    };
    var toggle = function() {
        if (optionsIds.includes(option._id)) {
            subtract();
        } else {
            add();
        }
    };
    var select = function() {
        if (optionsIds.includes(option._id)) {
            subtract();
        } else {
            onChange([
                option._id
            ]);
        }
    };
    var defaultAction = modifier.max === 1 ? select : option.max === 1 ? toggle : add;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(option.isOutOfStock ? (Option_styles_module_default()).optionOutOfStock : (Option_styles_module_default()).optionContainer, " ").concat(image ? (Option_styles_module_default()).optionContainerImage : ""),
        children: [
            image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((Option_styles_module_default()).imageContainer, " ").concat(count ? (Option_styles_module_default()).imageContainerSelected : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: option.image && option.image[0] ? option.image[0].imageLarge : null,
                        onClick: defaultAction,
                        alt: option.name,
                        className: "".concat((Option_styles_module_default()).optionImage, " ").concat(select ? (Option_styles_module_default()).optionImageSelected : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: option.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price_Price, Option_objectSpread({}, props))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Option_styles_module_default()).numberContainer,
                        children: [
                            count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Option_styles_module_default()).numberMinus,
                                onClick: subtract,
                                children: "-"
                            }) : null,
                            count ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Option_styles_module_default()).numberItems,
                                children: count
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Option_styles_module_default()).numberPlus, " ").concat(canAdd ? "" : (Option_styles_module_default()).hideInput),
                                onClick: add,
                                children: "+"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Option_styles_module_default()).optionLabel,
                    onClick: defaultAction,
                    "aria-label": option.name,
                    children: [
                        option.name,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Price_Price, Option_objectSpread({}, props))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(image ? (Option_styles_module_default()).hideInput : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, Option_objectSpread({}, props, {
                    count: count,
                    add: add,
                    subtract: subtract,
                    toggle: toggle,
                    select: select,
                    canAdd: canAdd
                }))
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/SelectionInfo/styles.module.css
var SelectionInfo_styles_module = __webpack_require__(61443);
var SelectionInfo_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectionInfo_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/SelectionInfo/index.tsx




function SelectionInfo(props) {
    var min = props.min, max = props.max, selected = props.selected;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.products.productsContent.selectProduct.inner.details.modifiers.modifier.selectionInfo"
    }).t;
    // only display information for multiple selection Modifiers.
    if (max === 1) return null;
    var infiniteMax = max === 0 || max == null;
    var rangeInfo = function() {
        // return if display range is not feasible.
        if (!infiniteMax && min > max) return null;
        // user understands that the min is 1.
        if (min <= 1) return null;
        if (min === max) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("labelSelectMin", {
                    min: min
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: t("labelSelectAtLeast", {
                min: min
            })
        });
    };
    var selectedInfo = function() {
        if (selected === 0) return null;
        if (selected === 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SelectionInfo_styles_module_default()).selected,
                children: t("labelSelectedProduct", {
                    selected: selected
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SelectionInfo_styles_module_default()).selected,
            children: t("labelSelectedProducts", {
                selected: selected
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            rangeInfo(),
            selectedInfo()
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/styles.module.css
var Modifier_styles_module = __webpack_require__(51693);
var Modifier_styles_module_default = /*#__PURE__*/__webpack_require__.n(Modifier_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/index.tsx








function Modifier(props) {
    var product = props.product, modifier = props.modifier, optionsIds = props.value, onChange = props.onChange;
    var options = modifier.options.filter(function(option) {
        return option.availabilityAt && option.availabilityAt.available;
    });
    var t = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }).t;
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var minSelection = modifier.min, maxSelection = modifier.max;
    var tagLabel = modifier.optional ? "optional" : "required";
    var tagClasses = "".concat(isDarkMode ? (0,classnames/* default */.Z)((Modifier_styles_module_default()).tag, (Modifier_styles_module_default()).tagDark) : (Modifier_styles_module_default()).tag, " ").concat(!modifier.optional ? isDarkMode ? (Modifier_styles_module_default()).notOptionalDark : (Modifier_styles_module_default()).notOptional : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Modifier_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Modifier_styles_module_default()).labelContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: tagClasses,
                        children: t(tagLabel)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifier_styles_module_default()).label,
                        children: modifier.name
                    }),
                    modifier.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifier_styles_module_default()).description,
                        children: modifier.description
                    }),
                    !!(optionsIds === null || optionsIds === void 0 ? void 0 : optionsIds.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifier_styles_module_default()).selectionInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionInfo, {
                            min: minSelection,
                            max: maxSelection,
                            selected: optionsIds.length
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Modifier_styles_module_default()).options, " ").concat(modifier.isImageModifier ? (Modifier_styles_module_default()).imageOptions : ""),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        optionsIds: optionsIds,
                        onChange: onChange,
                        option: option,
                        product: product,
                        modifier: modifier,
                        image: modifier.isImageModifier
                    }, option._id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/useMenuConfiguration.ts
function useMenuConfiguration_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useMenuConfiguration_templateObject() {
    var data = useMenuConfiguration_taggedTemplateLiteral([
        '\n      query getBlockMenuCommentsConfiguration_cached($websiteId: ID) {\n        sectionConfiguration(section: "menu", websiteId: $websiteId) {\n          _id\n          menu {\n            blockCommentsOnProducts\n          }\n        }\n      }\n    '
    ]);
    useMenuConfiguration_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useMenuConfiguration() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var sectionConfiguration = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(useMenuConfiguration_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).sectionConfiguration;
    if (!sectionConfiguration) return {};
    if (!sectionConfiguration.menu) return {};
    return sectionConfiguration.menu;
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Modifiers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Modifiers_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Modifiers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Modifiers_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














function Modifiers(props) {
    var product = props.product, state = props.state, onChange = props.onChange;
    var menuConfiguration = useMenuConfiguration();
    var isMobile = (0,useWidth/* default */.ZP)() < 768;
    var refs = (0,useRef/* default */.Z)({}).current;
    var ref1 = _slicedToArray((0,useState/* default */.Z)(), 2), shakingId = ref1[0], setShakingId = ref1[1];
    (0,useOnEvent["default"])("scrollToRequiredModifier", function() {
        var _ref = Modifiers_asyncToGenerator(runtime_default().mark(function _callee(modifier) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = refs[modifier._id];
                        if (ref) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        ref.scrollIntoView({
                            behavior: "smooth"
                        });
                        setShakingId(modifier._id);
                        _ctx.next = 7;
                        return (0,sleep/* default */.Z)(1500);
                    case 7:
                        setShakingId(null);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(modifier) {
            return _ref.apply(this, arguments);
        };
    }());
    if (!product.availabilityAt) return null;
    var modifiers = getFilteredModifiers(product.modifiers, state);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(simple_react_form_lib.Form, {
                state: state,
                onChange: onChange,
                children: [
                    modifiers.map(function(modifier, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "animated ".concat(shakingId === modifier._id ? "shake" : ""),
                            ref: function(ref) {
                                return refs[modifier._id] = ref;
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                                fieldName: "modifiers.".concat(modifier.index),
                                type: ObjectField/* default */.Z,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                                    fieldName: "optionsIds",
                                    type: Modifier,
                                    modifier: modifier,
                                    product: product
                                })
                            })
                        }, modifier._id);
                    }),
                    "blockCommentsOnProducts" in menuConfiguration && menuConfiguration.blockCommentsOnProducts ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                        fieldName: "comment",
                        type: Comments
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: 40
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useTrack.ts
var useTrack = __webpack_require__(25932);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Track.tsx


function Track(props) {
    var track = (0,useTrack/* default */.Z)();
    (0,useEffect/* default */.Z)(function() {
        track("viewProduct", {
            productId: props.productId
        });
    }, []);
    return null;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/styles.module.css
var Details_styles_module = __webpack_require__(97513);
var Details_styles_module_default = /*#__PURE__*/__webpack_require__.n(Details_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/index.tsx













var Details_translatePrefix = "order.products.productsContent.selectProduct.inner";
var OutOfStockOrUnavailableWarning = function(param) {
    var product = param.product;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)("website").t;
    var useSelectProductV2 = SelectProduct_useSelectProductModalV2();
    return product.isOutOfStock || !((ref = product.availabilityAt) === null || ref === void 0 ? void 0 : ref.available) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(warningBox/* default */.Z, {
        leftAligned: useSelectProductV2,
        children: product.isOutOfStock ? t("".concat(Details_translatePrefix, ".actions.labelProductOutOfStock")) : ((ref1 = product.availabilityAt) === null || ref1 === void 0 ? void 0 : ref1.notAvailableMessage) || t("".concat(Details_translatePrefix, ".actions.labelProductNotAvailable"))
    }) : null;
};
function Details(props) {
    var product = props.product;
    var t = (0,esm/* useTranslation */.$G)("website").t;
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    var useSelectProductV2 = SelectProduct_useSelectProductModalV2();
    var informativeStampsList = product === null || product === void 0 ? void 0 : product.informativeStamps;
    (0,useEffect/* default */.Z)(function() {
        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.VIEWCONTENT */.X.VIEWCONTENT, {
            product: product
        });
    }, [
        product._id
    ]);
    if (useSelectProductV2) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col flex-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overflow-auto flex-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col pt-6 px-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl font-bold mb-3 px-5",
                                children: product.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionTag/* default */.Z, {
                                product: product,
                                showPrice: false
                            }),
                            informativeStampsList && !!informativeStampsList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStampsV2/* default */.Z, {
                                    stamps: informativeStampsList,
                                    iconOnly: false
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockOrUnavailableWarning, {
                                product: product
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "px-5 descriptionTextColor",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MultilineText/* default */.Z, {
                                        children: product.description
                                    }),
                                    !!product.maxPurchaseQuantity && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "* ".concat(t("".concat(Details_translatePrefix, ".details.maxPurchaseQuantity"), {
                                            max: product.maxPurchaseQuantity
                                        }))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modifiers, {
                                product: product,
                                state: props.state,
                                onChange: props.onChange
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                    productId: product._id
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Details_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((Details_styles_module_default()).content, " dark:bg-black"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Details_styles_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (Details_styles_module_default()).name,
                                children: product.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionTag/* default */.Z, {
                                product: product,
                                showPrice: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Details_styles_module_default()).informativeStampsContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStampsV2/* default */.Z, {
                            stamps: informativeStampsList,
                            iconOnly: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockOrUnavailableWarning, {
                        product: product
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (Details_styles_module_default()).description,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultilineText/* default */.Z, {
                                children: product.description
                            }),
                            product.maxPurchaseQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "* ".concat(t("".concat(Details_translatePrefix, ".details.maxPurchaseQuantity"), {
                                    max: product.maxPurchaseQuantity
                                }))
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modifiers, {
                        product: product,
                        state: props.state,
                        onChange: props.onChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                productId: product._id
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/filterState.ts
function filterState_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function filterState_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filterState_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function filterOptionsState(state, product) {
    var ref1;
    var filteredModifiers = getFilteredModifiers(product.modifiers, state);
    return filterState_objectSpread({}, state, {
        modifiers: ((ref1 = state.modifiers) === null || ref1 === void 0 ? void 0 : ref1.map(function(modifier) {
            var modifierGroup = filteredModifiers.find(function(filteredModifier) {
                return filteredModifier._id === modifier.modifierId;
            });
            return filterState_objectSpread({}, modifier, {
                optionsIds: modifier.optionsIds.filter(function(optionId) {
                    var ref;
                    return modifierGroup === null || modifierGroup === void 0 ? void 0 : (ref = modifierGroup.options) === null || ref === void 0 ? void 0 : ref.find(function(option) {
                        return option._id === optionId;
                    });
                })
            });
        })) || []
    });
}

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getDefaultState.ts
function getDefaultState_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function getDefaultState_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            getDefaultState_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function getDefaultState(product, cartItem) {
    var productModifiers = (product === null || product === void 0 ? void 0 : product.modifiers) || [];
    if (cartItem) {
        return getDefaultState_objectSpread({}, cartItem, {
            modifiers: productModifiers.map(function(modifier) {
                var savedModifier1 = cartItem.modifiers.find(function(savedModifier) {
                    return savedModifier.modifierId === modifier._id;
                });
                return {
                    modifierId: modifier._id,
                    optionsIds: savedModifier1 ? savedModifier1.optionsIds || [] : []
                };
            })
        });
    }
    var modifiers = productModifiers.map(function(modifier) {
        return {
            modifierId: modifier._id,
            optionsIds: []
        };
    });
    return {
        modifiers: modifiers,
        comment: null,
        amount: 1
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getRemainingOptionsCount.ts
function getRemainingOptionsCount(modifier, count) {
    var min = modifier.min, optional = modifier.optional;
    if (optional && count === 0) return 0;
    var remainingOptions = min - count;
    return remainingOptions < 0 ? 0 : remainingOptions;
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getMissingModifier.ts
var getMissingModifier_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};


function getMissingModifiers(product, state) {
    var modifiers = (product === null || product === void 0 ? void 0 : product.modifiers) || [];
    if (!modifiers.length) return;
    var filteredModifiers = getFilteredModifiers(modifiers, state);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function(_iterator, _step) {
            var modifier = _step.value;
            if (modifier.optional && !modifier.min) return "continue";
            var stateModifier = state.modifiers.find(function(item) {
                return item.modifierId === modifier._id;
            });
            if (modifier.min) {
                var remainingOptions = getRemainingOptionsCount(modifier, stateModifier.optionsIds.length);
                if (remainingOptions > 0) {
                    return {
                        v: modifier
                    };
                } else {
                    return "continue";
                }
            }
            if (!stateModifier.optionsIds.length) {
                return {
                    v: modifier
                };
            }
        };
        for(var _iterator = filteredModifiers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop(_iterator, _step);
            if (getMissingModifier_typeof(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getPricePerItem.ts
function getPricePerItem(product, state) {
    var includeDiscount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!(product === null || product === void 0 ? void 0 : product.availabilityAt)) return;
    var price = includeDiscount ? product.availabilityAt.finalPrice : product.availabilityAt.basePrice;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop1 = function(_iterator, _step) {
            var _value = _step.value, modifierId = _value.modifierId, optionsIds = _value.optionsIds;
            var modifier1 = product.modifiers.find(function(modifier) {
                return modifier._id === modifierId;
            });
            if (!modifier1) return "continue";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function(_iterator1, _step1) {
                    var optionId = _step1.value;
                    var option1 = modifier1.options.find(function(option) {
                        return option._id === optionId;
                    });
                    if (!option1) return "continue";
                    if (!option1.availabilityAt) return "continue";
                    if (!option1.availabilityAt.price) return "continue";
                    price += option1.availabilityAt.price;
                };
                for(var _iterator1 = optionsIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true)_loop(_iterator1, _step1);
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        for(var _iterator = state.modifiers[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true)_loop1(_iterator, _step);
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return price;
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getResume.ts


function getResume(props, state, product) {
    var missingModifier = getMissingModifiers(product, state);
    var amount = state.amount;
    var unitPrice = getPricePerItem(product, state, true);
    var baseUnitPrice = getPricePerItem(product, state, false);
    return {
        ready: !missingModifier,
        missingModifier: missingModifier,
        price: amount * unitPrice,
        basePrice: amount * baseUnitPrice,
        amount: amount,
        unitPrice: unitPrice,
        baseUnitPrice: baseUnitPrice
    };
};

// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Images/styles.module.css
var Images_styles_module = __webpack_require__(658);
var Images_styles_module_default = /*#__PURE__*/__webpack_require__.n(Images_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Images/index.tsx







var ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2004).then(__webpack_require__.bind(__webpack_require__, 22004));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22004)
            ];
        }
    }
});
function Images(props) {
    var product = props.product;
    var useSelectProductV2 = SelectProduct_useSelectProductModalV2();
    if ((!product.images || !product.images.length) && !product.urlVideo) return null;
    if (product.images.length === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Images_styles_module_default()).imgContainer,
            children: product.urlVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                className: (Images_styles_module_default()).reactPlayer,
                url: product.urlVideo,
                width: "100%",
                height: "100%",
                muted: true,
                loop: true,
                config: {
                    vimeo: {
                        playerOptions: {
                            autoplay: true
                        }
                    },
                    youtube: {
                        playerVars: {
                            autoplay: 1
                        }
                    }
                },
                light: product.images[0].imageLarge
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (0,classnames/* default */.Z)((Images_styles_module_default()).image, {
                    "!object-cover": useSelectProductV2
                }),
                src: product.images[0].imageLarge,
                alt: product.altImg || product.name,
                title: product.titleImage || product.name
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Images_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
            showArrows: true,
            emulateTouch: true,
            showThumbs: false,
            showStatus: false,
            children: product.images.map(function(image, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Images_styles_module_default()).slide,
                    children: index === 0 && product.urlVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                        className: (0,classnames/* default */.Z)((Images_styles_module_default()).reactPlayer, {
                            "!object-cover": useSelectProductV2
                        }),
                        url: product.urlVideo,
                        width: "100%",
                        height: "100%",
                        muted: true,
                        loop: true,
                        config: {
                            vimeo: {
                                playerOptions: {
                                    autoplay: true
                                }
                            },
                            youtube: {
                                playerVars: {
                                    autoplay: 1
                                }
                            }
                        },
                        light: product.images[0].imageLarge
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (0,classnames/* default */.Z)((Images_styles_module_default()).image, {
                            "!object-cover": useSelectProductV2
                        }),
                        src: image.imageLarge,
                        alt: product.altImg || product.name,
                        title: product.titleImage || product.name
                    })
                }, index);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/styles.module.css
var Inner_styles_module = __webpack_require__(62953);
var Inner_styles_module_default = /*#__PURE__*/__webpack_require__.n(Inner_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Layout.tsx
function Layout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Layout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Layout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Layout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Layout_slicedToArray(arr, i) {
    return Layout_arrayWithHoles(arr) || Layout_iterableToArrayLimit(arr, i) || Layout_unsupportedIterableToArray(arr, i) || Layout_nonIterableRest();
}
function Layout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Layout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Layout_arrayLikeToArray(o, minLen);
}










function Layout(props) {
    var image = props.image, details = props.details, actions = props.actions, _promotionDetail = props.promotionDetail, promotionDetail = _promotionDetail === void 0 ? null : _promotionDetail;
    var width = (0,useWidth/* default */.ZP)();
    var scrollableContainer = (0,useRef/* default */.Z)(null);
    var ref = Layout_slicedToArray((0,useState/* default */.Z)(false), 2), showArrow = ref[0], setShowArrow = ref[1];
    var useSelectProductV2 = SelectProduct_useSelectProductModalV2();
    (0,useEffect/* default */.Z)(function() {
        var element = scrollableContainer.current;
        if (!element) return;
        var hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
        setShowArrow(hasVerticalScrollbar);
    }, []);
    var onScroll = function(event) {
        setShowArrow(false);
    };
    var arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
        in: showArrow,
        timeout: 500,
        children: function(state) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Inner_styles_module_default())["arrow_".concat(state)],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {
                    size: 50
                })
            });
        }
    });
    if (useSelectProductV2) {
        return width <= 768 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 overflow-auto relative",
                    ref: scrollableContainer,
                    onScroll: onScroll,
                    children: [
                        arrow,
                        image,
                        details
                    ]
                }),
                actions
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-1 w-full h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-1 w-1/2",
                    children: image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1 overflow-auto relative dark:bg-zinc-800",
                            ref: scrollableContainer,
                            onScroll: onScroll,
                            children: [
                                arrow,
                                details
                            ]
                        }),
                        actions,
                        promotionDetail ? promotionDetail : null
                    ]
                })
            ]
        });
    }
    return width <= 768 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Inner_styles_module_default()).containerMobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Inner_styles_module_default()).scrollable,
                ref: scrollableContainer,
                onScroll: onScroll,
                children: [
                    arrow,
                    image,
                    details
                ]
            }),
            actions
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Inner_styles_module_default()).containerDesktop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Inner_styles_module_default()).leftContent,
                children: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Inner_styles_module_default()).rightContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Inner_styles_module_default()).detailsDesktop,
                        ref: scrollableContainer,
                        onScroll: onScroll,
                        children: [
                            arrow,
                            details
                        ]
                    }),
                    actions,
                    promotionDetail ? promotionDetail : null
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/PromotionDetail/styles.module.css
var PromotionDetail_styles_module = __webpack_require__(78065);
var PromotionDetail_styles_module_default = /*#__PURE__*/__webpack_require__.n(PromotionDetail_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/PromotionDetail/promotionTypeActions.tsx



var promotionTypeActions = {
    buyOneGiveOne: {
        calculate: function(amount) {
            var promotionAmountRes = amount % 2;
            return {
                promotionAmountRes: promotionAmountRes,
                promotionAmount: (amount - promotionAmountRes) / 2
            };
        },
        text: function(param) {
            var promotionAmountRes = param.promotionAmountRes, promotionAmount = param.promotionAmount;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PromotionDetail_styles_module_default()).container,
                children: [
                    !!promotionAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PromotionDetail_styles_module_default()).hasPromotion,
                        children: esm/* i18n.t */.ag.t("promotionDetails.hasPromotion", {
                            promotionCount: promotionAmount * 2,
                            promotionAmount: promotionAmount,
                            ns: "website"
                        })
                    }),
                    !!promotionAmountRes && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PromotionDetail_styles_module_default()).carryMore,
                        children: esm/* i18n.t */.ag.t("promotionDetails.carryMore", {
                            missingItems: 2 - promotionAmountRes,
                            ns: "website"
                        })
                    })
                ]
            });
        }
    }
};
/* harmony default export */ var PromotionDetail_promotionTypeActions = (promotionTypeActions);

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/PromotionDetail/index.tsx



function PromotionDetail(props) {
    var product = props.product, amount = props.amount;
    var promotions = product.promotions;
    if (!(promotions === null || promotions === void 0 ? void 0 : promotions.length)) return null;
    var promotion = promotions[0];
    var promotionActions = PromotionDetail_promotionTypeActions[promotion.promotionType];
    if (!promotionActions) return null;
    var calculate = promotionActions.calculate(amount);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: promotionActions.text(calculate)
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx + 2 modules
var useAdd = __webpack_require__(80885);
// EXTERNAL MODULE: ./src/helpers/misc/hasWebpSupport.ts
var hasWebpSupport = __webpack_require__(6909);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getMergedModifiers.ts
function getMergedModifiers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function getMergedModifiers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            getMergedModifiers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function getMergedModifiers(productCached, productNonCached) {
    var productCachedModifiers = productCached.modifiers;
    var productNonCachedModifiers = productNonCached.modifiers;
    return productCachedModifiers.map(function(productCachedModifier) {
        var productNonCachedModifier = productNonCachedModifiers.find(function(modifier) {
            return modifier._id === productCachedModifier._id;
        });
        var productCachedModifierOptions = productCachedModifier.options;
        var productNonCachedModifierOptions = productNonCachedModifier.options;
        var options = productCachedModifierOptions.map(function(productCachedModifierOption) {
            var productNonCachedModifierOption = productNonCachedModifierOptions.find(function(option) {
                return option._id === productCachedModifierOption._id;
            });
            return getMergedModifiers_objectSpread({}, productCachedModifierOption, productNonCachedModifierOption);
        });
        return getMergedModifiers_objectSpread({}, productCachedModifier, {
            options: options
        });
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/productQueries.main.ts
function productQueries_main_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function productQueries_main_templateObject() {
    var data = productQueries_main_taggedTemplateLiteral([
        "\n  query getProductDetailsWeb_cached($productId: ID, $format: String, $websiteId: ID) {\n    product(productId: $productId, websiteId: $websiteId) {\n      _id\n      name\n      description\n      altImg\n      titleImg\n      urlVideo\n      informativeStamps\n      promotions {\n        _id\n        promotionType\n      }\n      images {\n        _id\n        url\n        imageLarge: resizedURL(width: 1200, height: 1200, format: $format)\n      }\n      categories {\n        _id\n        name\n        internalName\n      }\n      maxPurchaseQuantity\n      modifiers {\n        _id\n        name\n        description\n        min\n        max\n        optional\n        isImageModifier\n        options {\n          _id\n          name\n          max\n          requiresModifierOptionIds\n          image {\n            _id\n            url\n            imageLarge: resizedURL(width: 300, height: 300, format: $format)\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    productQueries_main_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = productQueries_main_taggedTemplateLiteral([
        "\n  query getProductDetailsNonCached(\n    $productId: ID\n    $menuId: ID\n    $websiteId: ID\n    $storeId: ID\n    $deliverAt: Date\n  ) {\n    product(productId: $productId, websiteId: $websiteId) {\n      _id\n      isOutOfStock(storeId: $storeId, deliverAt: $deliverAt)\n      availabilityAt(menuId: $menuId) {\n        available\n        basePrice\n        finalPrice\n        notAvailableMessage\n        hideDiscountBadge\n      }\n      modifiers {\n        _id\n        options {\n          _id\n          requiresModifierOptionIds\n          availabilityAt(menuId: $menuId) {\n            menuId\n            price\n            available\n          }\n          isOutOfStock(storeId: $storeId, deliverAt: $deliverAt)\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var getProductDetailsCached = (0,lib["default"])(productQueries_main_templateObject());
var getProductDetails = (0,lib["default"])(_templateObject1());

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useProduct.ts
function useProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function useProduct(param) {
    var websiteId = param.websiteId, productId = param.productId, menuId = param.menuId, storeId = param.storeId, deliverAt = param.deliverAt;
    var variables = {
        websiteId: websiteId,
        productId: productId,
        menuId: menuId,
        storeId: storeId,
        deliverAt: deliverAt,
        format: (0,hasWebpSupport/* default */.Z)() ? "webp" : "jpeg"
    };
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getProductDetailsCached,
        variables: variables
    }), productCached = ref.product;
    var ref1 = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getProductDetails,
        variables: variables
    }), productNonCached = ref1.product;
    return useProduct_objectSpread({}, productNonCached, productCached, {
        modifiers: getMergedModifiers(productCached, productNonCached)
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/index.tsx
function Inner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Inner_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Inner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Inner_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Inner_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Inner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Inner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Inner_slicedToArray(arr, i) {
    return Inner_arrayWithHoles(arr) || Inner_iterableToArrayLimit(arr, i) || Inner_unsupportedIterableToArray(arr, i) || Inner_nonIterableRest();
}
function Inner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Inner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Inner_arrayLikeToArray(o, minLen);
}


















function Inner(props) {
    var close = props.close, cartItem = props.cartItem, _allowEdit = props.allowEdit, allowEdit = _allowEdit === void 0 ? true : _allowEdit;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var data = (0,getMyOrderPreferencesSlim_main/* useMyOrderPreferencesSlim */.b)(websiteId, {
        partial: false
    }).data;
    var ref5;
    var ref1 = (ref5 = data === null || data === void 0 ? void 0 : data.preferences) !== null && ref5 !== void 0 ? ref5 : {}, deliverAt = ref1.deliverAt, storeId = ref1.storeId, menuId = ref1.menuId;
    var website = (0,websiteMenuInformation_main/* useWebsiteMenuInformation */.g9)().website;
    var webLayout = website === null || website === void 0 ? void 0 : website.layout;
    var add = (0,useAdd/* default */.Z)();
    var product = useProduct({
        deliverAt: deliverAt,
        storeId: storeId,
        menuId: menuId,
        productId: props.product._id,
        websiteId: websiteId
    });
    var ref2 = Inner_slicedToArray((0,useState/* default */.Z)(getDefaultState(product, cartItem)), 2), rawState = ref2[0], setState = ref2[1];
    var state = filterOptionsState(rawState, product);
    var ref3 = Inner_slicedToArray((0,useState/* default */.Z)(false), 2), loading = ref3[0], setLoading = ref3[1];
    var resume = getResume(props, state, product);
    var image = /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
        product: product
    });
    var details = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Inner_styles_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
            state: state,
            product: product,
            onChange: function(changes) {
                return setState(Inner_objectSpread({}, state, changes));
            }
        })
    });
    var promotionDetail = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Inner_styles_module_default()).actions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionDetail, {
            product: product,
            amount: state.amount
        })
    });
    var actions = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Inner_styles_module_default()).actions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner_Actions, {
            product: product,
            allowEdit: allowEdit,
            isOutOfStock: product.isOutOfStock,
            state: state,
            resume: resume,
            isAddingToCart: loading,
            add: function() {
                var ref, ref4;
                return add(Inner_objectSpread({}, props, ((ref = data.preferences) === null || ref === void 0 ? void 0 : ref.menuId) && {
                    menuId: (ref4 = data.preferences) === null || ref4 === void 0 ? void 0 : ref4.menuId
                }), state, product, resume, {
                    setLoading: setLoading
                });
            },
            cartItem: cartItem,
            close: close,
            layout: webLayout,
            onChange: function(changes) {
                return setState(Inner_objectSpread({}, state, changes));
            }
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                image: image,
                details: details,
                actions: actions,
                promotionDetail: promotionDetail
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/styles.module.css
var SelectProduct_styles_module = __webpack_require__(58071);
var SelectProduct_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectProduct_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx
function SelectProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SelectProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SelectProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















function SelectProduct(props) {
    var preferences = (0,usePreferencesForAddressContext_main/* default */.Z)().preferences;
    var product = props.product, closeModal = props.close, open = props.open;
    var useSelectProductV2 = SelectProduct_useSelectProductModalV2();
    var handleClose = function() {
        if (!open) return;
        closeModal();
    };
    var handleClickOutside = function() {
        if (document.getElementById("v3_modal")) return;
        // This is hacky, but couldn't think of a better way to prevent the click outside when there are two modals open
        handleClose();
    };
    (0,useKeyboardEvent/* default */.Z)("escape", function() {
        handleClose();
    });
    (0,useDisableScroll/* default */.Z)(open);
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    var content = !useSelectProductV2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classnames/* default */.Z)({
            dark: isDarkMode
        }),
        children: [
            open ? (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "e89170ede354f9dc",
                children: "body{overflow:hidden}"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
                in: open,
                timeout: 350,
                /*#__PURE__*/ children: function(state) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SelectProduct_styles_module_default()).container + " " + (SelectProduct_styles_module_default())["container_" + state],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.Z, {
                            onClickOutside: handleClickOutside,
                            className: (SelectProduct_styles_module_default()).dialog + " " + (SelectProduct_styles_module_default())["dialog_" + state],
                            children: state === "exited" ? null : //Modifying this nested structure of the modal is likely to break the scroll in mobile
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "close-modal-product",
                                        className: (SelectProduct_styles_module_default()).close,
                                        onClick: handleClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                                            size: 30,
                                            className: "dark:fill-current text-black"
                                        })
                                    }),
                                    product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, SelectProduct_objectSpread({}, props), product._id)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SelectProduct_styles_module_default()).center,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                                    })
                                ]
                            })
                        })
                    });
                }
            })
        ]
    });
    var contentv2 = useSelectProductV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classnames/* default */.Z)({
            dark: isDarkMode
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed z-[10000] inset-0 flex justify-center items-end md:items-center overflow-hidden ".concat(open ? "transition-colors ease-in duration-200 visible bg-black/[0.7]" : "invisible"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(build/* default */.Z, {
                onClickOutside: handleClickOutside,
                className: "\n              backgroundColor textColor relative top-[10vh] flex flex-col w-full md:w-[calc(100vw-40px)] max-w-[1200px] h-full md:h-[600px] mt-5 md:mt-0 max-h-[98dvh] overflow-hidden\n              md:rounded-2xl md:flex-row ".concat(open ? "top-0 transition-all ease-in duration-200 opacity-100 -translate-y-[10vh]" : "opacity-20"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "close-modal-product",
                        className: (0,classnames/* default */.Z)("absolute right-4 top-3 cursor-pointer z-[1200] bg-white w-30 h-30 flex items-center justify-center rounded-full", "dark:bg-zinc-600"),
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                            size: 30,
                            className: "dark:fill-current dark:text-zinc-400 text-black"
                        })
                    }),
                    product ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, SelectProduct_objectSpread({}, props), product._id)
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full self-center text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ react_dom.createPortal(useSelectProductV2 ? contentv2 : content, document.querySelector("#modal-root"));
}
function WrappedSelectProduct(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct, SelectProduct_objectSpread({}, props))
    });
};


/***/ }),

/***/ 1829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WarningBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89894);



function WarningBox(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_helpers_misc_classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("w-full max-w-xs flex", props.leftAligned ? "justify-start" : "justify-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "p-2 mx-5 my-2 text-sm bg-amber-500 text-white text-left rounded",
            children: props.children
        })
    });
};


/***/ }),

/***/ 56477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_3fjtgEVPfQMdW4VsJNRfCh"};

/***/ }),

/***/ 1795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JoRnTgEaun7ZtSEiC9Sz1","button":"_2Gylcs6Gd7UanqPc-RfSRs"};

/***/ }),

/***/ 81251:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price":"_1ZVK-WnvIjmbUPRxOCBFQC","button":"_11W5zOCypddQ7ph1AZaAwH"};

/***/ }),

/***/ 58471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Ds2lk386UyIuMcV-nvmDH","containerDark":"MCpFtwq-Us0zwHVkd5t-M","inner":"SlT6i0zpq7ili5AVrEumo","options":"_2yS7O6Ld0Uiac1lHvdyiaF","amount":"_2ZMLX05i7jy0YC8GT8Vwwf","amountValue":"_26MYC0Sn55yJb88PvsahZ7","amountButton":"_2sNUjvormrWpWJWF7PN7f7 buttonShadow textColor","amountButtonDark":"_2tOER3aQ-08WY6xDMKIIbj","button":"utsr2lmGxCnCqAjK8vs4p","buttonLegacy":"NoPQwuZa0sb_GwdW8QnzI","price":"_3kAJ7tjAKAJGta8ThwS8yn","selectStore":"_3uT5HRRM0qPJ1MeI5wXXda","outOfStockMessage":"_3R_2o2wTZ_6OoipvxttEvl orion_button orion_disabled"};

/***/ }),

/***/ 85792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"xerH9vwSvQ7VEdXkx8zAf","containerDisabled":"_2QTUUU1ewsuWVb84_fHbpm"};

/***/ }),

/***/ 9899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BuWWgPYDqG250C3qMov-H","containerDisabled":"_2K2mlwL6l06aYanhKdylpd","activeContainer":"_3_Qn-2M_TvQ5UkcfGvqzSW","icon":"_2lWxkLrkXPQZaASNV0manc","iconDisabled":"_1FAieCOwHu4Y-vtbmBSPmg","count":"_31f_67zycVqytnxGcQCsSh"};

/***/ }),

/***/ 12563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3kV27tvAhzpj1LNK72PZue"};

/***/ }),

/***/ 94622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price":"_2hxnD5Lx2ip3InWc1Aertb","outOfStock":"QU8zNhr5kHvXmba3FYMML","outOfStockDark":"_2JzU136_EOA46GONshMGwQ"};

/***/ }),

/***/ 84715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"y4dYaokeIIGrzmqxg8Ayo","optionContainer":"_1W9OVcVbyb_pP9au5t9Peh","optionContainerImage":"_1O_d8Yg0vlaA61UG0E4vjd","optionOutOfStock":"_3u5xbaoTY5p0J7bZPatNqj _1W9OVcVbyb_pP9au5t9Peh","optionLabel":"XX5pjJEPk_efWwTQ_cxHX","optionImage":"_3oA9hhZ_JzmQWFwdHKWV-l","hideInput":"E5--VQrULLV7IoNNuQn3b","imageContainer":"_44HEuI20QKAc9phkZ4btU","imageContainerSelected":"_32GvzY3Js1R98oenHljKeD","numberContainer":"_1mk5Ig4v4yZIOnrFIl1kPj","numberItems":"_3gzF_F--GZM5tMIk5gszkt","numberMinus":"_1FiC_TIPGi5eXqiNLKwlEa","numberPlus":"doLORol8EHShgNhoju3IT"};

/***/ }),

/***/ 61443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selected":"_2WEZ-nLsOkFOeisQ1AuMRb"};

/***/ }),

/***/ 51693:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"kLUSDCp4arP0T3QFI4BmX","labelContainer":"_1cugaZDZnAIYqz2RTnCMpk","label":"_77RG7gSF_oHyesFG79_Ts","description":"_2lGoFssr_gZRg8J1Klq_Cg","tag":"_29bt6nvWMHpvR_r57gf1zt","tagDark":"_1lKDFRd6iT_YLjsuTop9X-","notOptional":"cnpdcjTUTd89ap-Lcz079","notOptionalDark":"_3n2XGEjFKMfox-Lfxt_-Te","selectionInfo":"_1sozssAaggLkDFtqnMVAIu","options":"_3S3ZJYyrIVf0r62n_zei8b","imageOptions":"_28awjLkSowcaCQY-x97CDZ"};

/***/ }),

/***/ 45546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gtX98axT987NNuVNgqAnC","labelContainer":"_2hEyEszJqyXUDbcLOzWhwq textColor","label":"_1GraXf-dADpgnQwE0t62Ms","description":"_2UyP4Q-ftkVbiLxZZVG4aV","notOptional":"FTbO4_uDt1CJfcOMzlxBG","textarea":"RCPEHPK-OcYLWNS_jnXqB secondaryBackgroundColor textColor","optionContainer":"_1ck6IsTsDqme2PH_IRyR0E","optionOutOfStock":"x7Hk9DReSXZWDFVNVpM26 _1ck6IsTsDqme2PH_IRyR0E","optionLabel":"_1ewo791xmwKLXPDtT1KqNy","input":"k7HJ9aK0F8srCkLcHBwPm","price":"u_WyTPujNnuuoSR01xqC6 descriptionTextColor","outOfStock":"_2NZH9iKtZ_i7jxk83Vi21a"};

/***/ }),

/***/ 97513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1iadtdx2dCglITsAF7LVS6","content":"_2NGCbm7SldrDsMh4ZJTHU9","actions":"_3IRXxdt0lEbY1_3_o2vyej","name":"_3RsV8R40NNJ9jK-NrhRZx9 selectProductName","description":"FM-CatORsTn2R1JU7M6ji selectProductDescription descriptionTextColor","promotion":"tgVXkt6dnETvEspuV64SP","title":"_35I6OEu7tx_SXr3Q331LNz","informativeStampsContainer":"_2fY0q2iES4bQLVVdFDQN7A"};

/***/ }),

/***/ 658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3W6IztQUSTBfCNJFPl4ItX","imgContainer":"_3stT25Od4PxV9_wzgXO4Av","image":"gMI2mb51kuAVpRqCmS22","slide":"_2RAsqHbz1YcrVnpu14H57w","reactPlayer":"_3EAFqObRTLt_UAI9mxBOnT"};

/***/ }),

/***/ 78065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hasPromotion":"_3B-pbTb4gjIgDVNkdbLrk","carryMore":"_1MSHlmKrojDER-B3Suf1dC","container":"_2QklPxMlV0Ex4FttO23vkh"};

/***/ }),

/***/ 62953:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"_3bdyN5X1w628ddqSFWNIbA","containerMobile":"_3y-fZjlt5EjfcpJv0j7Wn_","scrollable":"_2i_tz5gNfy2gn9ChXR9aNj","containerDesktop":"_1mJlXNibvXRVrfPi4Z6ebf","leftContent":"_1T6Zt2KD6v-ZwJrkBiapd9","rightContent":"_2wav8mmR1lM-kRtpqu2ckl","detailsDesktop":"_1jJDyvSFSK_hegHAbVxunE","arrow":"_2xbdpTyIC_XKAkhoagXd2Y animated pulseAnimation textColor","arrow_exited":"_1LQvFkXBefZkdCGlArkytV _2xbdpTyIC_XKAkhoagXd2Y animated pulseAnimation textColor","arrow_entering":"_26oQ_DpTL3GBEbIkk0hkKk _2xbdpTyIC_XKAkhoagXd2Y animated pulseAnimation textColor","arrow_entered":"_11qpLIaaLcpp1SvGjGqEw_ _2xbdpTyIC_XKAkhoagXd2Y animated pulseAnimation textColor","arrow_exiting":"Qp2EzSoxo0MvbXiBMtq8l _2xbdpTyIC_XKAkhoagXd2Y animated pulseAnimation textColor"};

/***/ }),

/***/ 58071:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3qm0leIlOCB8bqNfSIRtLd selectProductMenuContainer","container_exited":"_26VWVQY6qjzLakwkj4BiJ_","container_entering":"OcYH6syZV9fOm70yx6t0r","container_entered":"BGBfm51axrPbccRzOg_xr","container_exiting":"_2K2_Sot0cXgYRVXhS-O4hg","dialog":"_1_8EDJjeObbvBm2nhNqjc- backgroundColor textColor","dialog_exited":"_103h_O70FAfAWAJ5ejr4zt","dialog_entering":"_2_Gvk0Rhehaegv-XW362rj","dialog_entered":"_31d_xh7sVufzXKmyKgxajn","dialog_exiting":"jQjbDF1P2LgnZHEIyIA6_","close":"_1Ls29xfDQHSlASwBajrMGK","center":"_2loOKi2Csl68NtO2yZp6nb"};

/***/ })

}]);